import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal, WritableSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, ActivatedRoute, NavigationEnd, RouterLink } from '@angular/router';
import { Breadcrumb } from '@models/breadcrumb.model';
import { Store } from '@ngrx/store';
import { selectAppCmsCopy } from '@selectors/cms.selector';
import { filter } from 'rxjs';

@Component({
  selector: 'app-breadcrumbs',
  standalone: true,
  imports: [RouterLink, NgClass],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent {
  static ROUTE_DATA_BREADCRUMB = 'breadcrumb';
  
  store = inject(Store);
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);

  appCopySig = toSignal(this.store.select(selectAppCmsCopy));
  breadcrumbsSig: WritableSignal<Breadcrumb[]> = signal(this.createBreadcrumbs(this.activatedRoute.root));

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.breadcrumbsSig.set(this.createBreadcrumbs(this.activatedRoute.root)));
  }
  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    children.forEach(child => {
      const routeUrl: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeUrl !== '') {
        url += `/${routeUrl}`;
      }

      const label = this.appCopySig()?.[child.snapshot.data[BreadcrumbsComponent.ROUTE_DATA_BREADCRUMB]];
      if (!!label && !!routeUrl) {
        breadcrumbs.push({label, url});
      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    });

    return breadcrumbs;
  }
}
